"use client";

import { ReaderAcquireFailure } from "@/app/_providers/StripeTerminalProvider";
import PaymentNotice from "@/app/_components/Payment/PaymentNotice/PaymentNotice";

interface ReaderFailureNoticeProps {
  failure: ReaderAcquireFailure;
  // Fact + reason copy for the non-busy cases (offline, not reachable...).
  message: string;
}

// Shown on the payment screens when Process could not take the reader.
// Process below is the retry in every case.
//
// Busy means another device is mid card read. There is deliberately no way
// to take the reader from here: it would cancel a real customer's payment on
// that device. A reader stuck on the card screen (a closed tab, a phone left
// mid payment) is freed with Cancel on the reader itself, which every card
// read allows (enable_customer_cancellation).
export const ReaderFailureNotice = ({
  failure,
  message,
}: ReaderFailureNoticeProps) =>
  failure === "busy" ? (
    <PaymentNotice
      tone="wait"
      title="Reader in use"
      message="Another device is taking a payment on it. Wait until it finishes, then press Process. If nobody is using it, press Cancel on the reader."
    />
  ) : (
    <PaymentNotice title="Card reader" message={message} />
  );

export default ReaderFailureNotice;
